import { Button, Icon } from '@innovationnorway/cl-react';
import React from 'react';

type AddEditButtonProps = {
  hasSelection: boolean;
  addLabel: string;
  editLabel: string;
  onClick: () => void;
  type?: 'button' | 'submit' | 'reset';
  className?: string;
};

const AddEditButton: React.FC<AddEditButtonProps> = ({
  hasSelection,
  addLabel,
  editLabel,
  onClick,
  type = 'button',
  className,
}) => (
  <Button icon variant="tertiary" className={className} type={type} onClick={onClick}>
    <Icon prefix="fasr" iconName={hasSelection ? 'pen' : 'plus'} />
    {hasSelection ? editLabel : addLabel}
  </Button>
);

export default AddEditButton;
